<template>
  <div class="modal-recommendations">
    <div class="top-right">
      <button @click="$emit('close')">
        x
      </button>
    </div>
    <div class="list-recommendations">
      <div class="title-recommendations">
        <span class="title">Vous avez apprécié ?</span>
        <span class="subtitle">Venez laisser votre avis sur nos plateformes de recommandations !</span>
      </div>
      <div class="list-item-recommendations">
        <div class="item-recommendations" v-for="reco in recommendations" :key="reco.id">
          <a :href="reco.link" target="_blank"><img :src="require(`@/assets/media_logo/${reco.label}_logo.png`)"></a>
          {{ nameLabel(reco.label) }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import remoteConfig from '@/lib/remote-config'


export default {
  name: 'VvModal',
  components: {},
  props: {},
  data() {
    return {
    }
  },
  computed: {
    // Format JSON string from remote config
    recommendations() {
      if (remoteConfig.getValue('recommendations')) {
        return JSON.parse(JSON.parse(JSON.stringify(remoteConfig.getValue('recommendations'))))
      }
      return []
    },
  },
  methods: {
    nameLabel(e) {
      return e[0].toUpperCase() + e.substring(1)
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/styles/_variables.scss';

.modal-recommendations {
  height: 300px;
}

.top-right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  margin: 10px;
  @media screen and (max-width: 450px) {
    margin: 5px;
  }

  button {
    border: none;
    outline: none;
    background: none;
  
    &:hover {
      cursor: pointer;
    }
  }
}

.list-recommendations {
  display: flex;
  margin-left: 20px;
  margin-right: 20px;
  flex-direction: column;
  align-content: center;
  justify-content: flex-start;
  align-items: center;
  height: 270px;

  .title-recommendations {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: center;
    margin-bottom: 40px;

    .title {
      font-weight: bold;
      font-size: medium;
      margin-bottom: 5px;
    }

    .subtitle {
      font-size: small;
    }
  }

  .list-item-recommendations {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;

    .item-recommendations {
      display: flex;
      flex-direction: column;
      align-content: center;
      justify-content: center;
      flex-wrap: wrap;
      align-items: center;
      margin-left: 30px;
      margin-right: 30px;
      margin-bottom: 20px;
      @media screen and (max-width: 450px) {
        margin-left: 15px;
        margin-right: 15px;
        margin-bottom: 10px;
      }
  }
    img {
      width: 80px;
      height: 80px;
      @media screen and (max-width: 450px) {
        width: 60px;
        height: 60px;
      }
    }
  }
}


</style>
